import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "child-list-header border-0 border-b border-solid border-standard-bg w-full" }
const _hoisted_2 = {
  key: 0,
  class: "child-lists flex"
}

import { computed } from 'vue';
import { useStore } from 'vuex';
import useSwimlanes from '../../boards/composables/useSwimlanes';
import BoardListHeader from '@/components/widgets/BoardListHeader.vue';
import BoardList from '@/components/widgets/BoardList.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SwimlanesList',
  props: {
  listId: {
    type: String,
    required: true,
  },
  mainListIds: {
    type: Array,
    required: true,
  },
  maxDisplayedLists: {
    type: Number,
    default: 4,
  },
  position: {
    type: Number,
    required: false,
    default: 0,
  },
  containerWidth: {
    type: Number,
    required: false,
    default: 0,
  },
  emptyMainLists: {
    type: Array,
    required: false,
    default: () => [],
  },
},
  setup(__props) {

const {
  boardSubGroupBy,
  showStatusIconPickerSubGroup,
  currentBoardId,
  subGroupByObject,
  hideEmptyGroups,
} = useSwimlanes();

const store = useStore();

const props = __props;

const listExpanded = computed(() => {
  return store.getters.getListExpanded(currentBoardId.value, props.listId);
});

const listCards = computed(() => {
  const listCards: string[] = [];
  for (const mainListId of props.mainListIds) {
    const listId = mainListId as string | number;
    const propListId = props.listId;
    if (subGroupByObject.value?.[listId] && subGroupByObject.value[listId]?.[propListId]?.cardIds) {
      listCards.push(...(subGroupByObject.value[listId]?.[propListId]?.cardIds || []));
    }
  }
  return listCards;
});

// Check if main list is in the emptyMainLists array
const isMainListEmpty = (mainListId: unknown) => {
  return props.emptyMainLists.includes(String(mainListId));
};

const isEmptyGroup = computed(() => {
  return hideEmptyGroups.value && !listCards.value.length;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["child-list-content flex flex-col", {
      'empty-group': isEmptyGroup.value,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(BoardListHeader, {
        "list-id": props.listId,
        "header-footer-style": {},
        expandable: true,
        "show-status-icon-picker": _unref(showStatusIconPickerSubGroup),
        "disable-status-icon-picker": true,
        "group-by": _unref(boardSubGroupBy),
        "list-cards": listCards.value,
        visible: true,
        "is-cards-layout-timeline": false,
        "is-epic-board": false
      }, null, 8, ["list-id", "show-status-icon-picker", "group-by", "list-cards"])
    ]),
    _cache[0] || (_cache[0] = _createTextVNode()),
    (listExpanded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.mainListIds, (parentList, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["child-list-cards flex flex-col overflow-auto", {
          'empty-group': isMainListEmpty(parentList),
        }])
            }, [
              _createVNode(BoardList, {
                ref_for: true,
                ref: `boardList-${props.listId}`,
                visible: true,
                "list-id": props.listId,
                "parent-list-id": parentList,
                index: index,
                "large-board": false,
                "max-displayed-lists": __props.maxDisplayedLists,
                expandable: true,
                position: __props.position,
                "container-width": __props.containerWidth,
                "sprint-disable-drag": true,
                "show-add-card-button": true,
                "show-list-header": false
              }, null, 8, ["list-id", "parent-list-id", "index", "max-displayed-lists", "position", "container-width"])
            ], 2))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})